module.exports = __webpack_public_path__ + "img/provider8.3bbb5c9d.png";